/**
 * Navigation interne (bloc inner_navigation) : ancres en scroll doux, sélecteur mobile,
 * classe `sticky` quand le bloc atteint le haut de l'écran.
 * Remplace le composant Vue InnerNavigation (+ directive v-scroll).
 */
UNYC.register('inner-navigation', () => {
    UNYC.init('[data-inner-navigation]', 'inner-navigation', (section) => {
        const select = section.querySelector('select[name="anchor-select"]');
        const links = UNYC.qsa('.navigation a', section);

        const goTo = (target) => {
            UNYC.scrollTo(target.charAt(0) === '#' ? target : `#${target}`);
        };

        if (select) {
            select.addEventListener('change', () => goTo(select.value));
        }

        links.forEach((link) => {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                goTo(link.hash);
            });
        });

        const updateSticky = () => {
            const offset = section.offsetTop - window.scrollY;
            const limit = window.innerWidth < 1024 ? 90 : 70;

            section.classList.toggle('sticky', offset <= limit);
        };

        window.addEventListener('scroll', UNYC.throttleFrame(updateSticky), { passive: true });
        updateSticky();
    });
});
